import type {
    CoverableChangeDTO,
    CoverageOpcDTO
} from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/opc';
import { selector } from 'recoil';
import { OnlineSales } from 'gw-edge-client';
import { opcInfoAtom } from '../atoms/opcInfoAtom';
import { jobInfoAtom } from '../atoms/jobInfoAtom';

export const getExistingCoveragesSelector = selector<CoverageOpcDTO[]>({
    key: 'getExistingCoveragesSelector',
    get: async ({ get }) => {
        const opcInfo = get(opcInfoAtom);
        const { productName, coverableId } = opcInfo;
        const { jobNumber } = get(jobInfoAtom);
        const coverableChangeDTO: CoverableChangeDTO = {
            coverableId,
            productName
        };
        const existingCoverages = await OnlineSales.getCoveragesForOPC(
            jobNumber,
            coverableChangeDTO
        );
        return existingCoverages;
    }
});
